import { AssetEditorProvider } from "@/context/asset-editor-provider";
import AssetsList from "./assets-list-responsive";
import { VisionManagerProvider } from "@/context/vision-manager-provider";

// AssetsOverviewList: specifically for showing the asset list in console context (/console/assets)
export const AssetsOverviewList = () => {
  return (
      <AssetEditorProvider>
        <AssetsList />
      </AssetEditorProvider>
  );
};
